import { Component } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import moment from 'moment';

@Component({
    selector: 'app-storage-rates',
    templateUrl: './storage-rates.component.html',
    styleUrls: ['./storage-rates.component.scss'],
    standalone: false
})
export class StorageRatesComponent {

  buttons: GridButton[] = [
    {label: 'Edit', link: '/warehousing/storage-rates/edit/:id', type: 'btn-warning',} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Customer', field: 'account.name'} as GridColumn,
    {active: true, label: 'Unit', field: 'unit.name'} as GridColumn,
    // Blank is the account-wide rate, and says so rather than showing an empty cell.
    {active: true, label: 'Product', field: 'productId', value: (v, r) => r.productId ? r.productId : 'All products'} as GridColumn,
    {active: true, label: 'Storage (per unit/day)', field: 'storageRatePerDay', value: v => this.money(v)} as GridColumn,
    {active: true, label: 'RH&D (per unit)', field: 'rhdRate', value: v => this.money(v)} as GridColumn,
    {active: true, label: 'Effective From', field: 'effectiveFrom', value: v => v ? moment(v).format('DD/MM/YYYY') : ''} as GridColumn,
  ];

  filters: GridFilter[] = []

  searchFields: any = ['account.name'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'account.name',
      label: 'Customer',
    } as GridSearchFilter,
  ]

  /** The driver hands DECIMAL back as a string, so this formats the value it actually receives. */
  money(value: any): string {
    return (value === null || value === undefined || value === '')
      ? ''
      : '£' + Number(value).toFixed(4);
  }
}
